// extracted by mini-css-extract-plugin
module.exports = {"accountMenuItem":"AccountMenuItem_accountMenuItem__1JAAh","menuText":"AccountMenuItem_menuText__2Akqb","isActive":"AccountMenuItem_isActive__3bQEu"};